import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

export const mapStateToProps = (state: State) => ({
	userIsOnboarded: state.domain.userIsOnboarded,
});
